/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Benefits_Title_3Inputs */

const et_benefits_title_3 = /** @type {(inputs: Benefits_Title_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pikaajaline strateegia`)
};

const en_benefits_title_3 = /** @type {(inputs: Benefits_Title_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long-term strategy`)
};

/**
* | output |
* | --- |
* | "Long-term strategy" |
*
* @param {Benefits_Title_3Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const benefits_title_3 = /** @type {((inputs?: Benefits_Title_3Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Benefits_Title_3Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_benefits_title_3(inputs)
	return en_benefits_title_3(inputs)
});